export default __webpack_public_path__ + "static/dropdownBottomS-e0b6de9cdd130827767eaff5aff85abb.png";